import { FaSearch } from 'react-icons/fa';
import { TiSocialLinkedin } from 'react-icons/ti';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';


const Questions = () => {
  return (
    <div>
             

            <div className="questions-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12">
                            <div className="frequently-asked-questions-box">
                                <h3>Questions</h3>
                                <div className='question-form'>
                                    <input type="text" />
                                    <button><FaSearch /></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         
            <Footer />


        </div>
  )
}

export default Questions
